<template>
  <div class="bottom_pass">
    <div class="bottom_pass_box">
      <div class="flexCenter">
        <div class="jc">
          <div class="logo">
            <img :src="$imgUrl + 'home/bottomlogo.png'"
                 alt="">
          </div>
          <div style="font-size:12px">新零售实体门店·一站式解决方案</div>
          <div style="margin-top:42px;display:flex">
            <div class="imgItem">
              <div style="width:110px;height:110px;background-color: #fff;padding: 3px;box-sizing: border-box;margin-left:5px">
                <el-image style="width: 104px; height: 104px;"
                          :src="$imgUrl + 'home/buttom_jc.png'"></el-image>
              </div>
              <div style="font-size:12px;margin-top: 4px;">关注钧策咨询公众号</div>
            </div>
            <div class="imgItem">
              <div style="width:110px;height:110px;background-color: #fff;padding: 3px 2px 3px 3px;box-sizing: border-box;margin-left:5px">
                <el-image style="width: 104px; height: 104px;"
                          :src="$imgUrl + 'home/buttom_djt.png'"></el-image>
              </div>
              <div style="font-size:12px;margin-top: 4px;">关注零售大讲堂公众号</div>
            </div>
          </div>
        </div>
        <div class="fa">
          <div v-for="(item,index) in list"
               :key="index"
               class="fa_item">
            <div class="title">{{item.title}}</div>
            <div class="li_item"
                 @click="toLink(x)"
                 v-for="(x,y) in item.temp"
                 :key="y+'y'">
              {{x.text}}
            </div>
          </div>
        </div>
        <div class="lx">
          <div style="font-size:16px;color: #fff;">联系方式</div>
          <div style="font-size:30px;margin:29px 0 11px 0;color: #fff;font-weight: bold;">027-87209668</div>
          <div style="color: #fff;font-size:12px;">周一至周五 08:30-19:00</div>
          <div style="font-size:12px;margin:30px 0 24px 0">商务邮箱: 2743934058@qq.com</div>
          <div style="font-size:12px">联系地址: 湖北省武汉市洪山区现代世贸中心C座</div>
        </div>
      </div>
      <div class="bottom">
        友情链接 <span style="margin-right:20px"
              v-for="(item,index) in links"
              :key="index"
              @click="$Public.link(item)">{{item.titleName}}</span>
      </div>
      <div class="bottom">
        鄂公网安备 <a href="https://beian.miit.gov.cn/"
           style="color:#fff"
           target="_blank">{{ filingNumber }}</a>
        <!-- <span @click="toGov">鄂ICP备11008218号-1</span> 网上有害信息举报专区 -->
      </div>
    </div>
  </div>
</template>

<script>
import { resourceList } from '@/api/api.js'
export default {
  name: 'bottom_pass',
  data () {
    return {
      filingNumber: '鄂ICP备11008218号-1',
      data: {
        showIndex: 25,
        pageNumber: 1,
        pageSize: 100
      },
      links: [],
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
      list: [
        {
          title: '解决方案',
          temp: [{
            text: '咨询顾问',
            path: '/Consultant'
          },
          {
            text: '零售培训',
            path: '/RetailTraining'
          },
          {
            text: '零售老板圈',
            path: '/Bosscircle'
          },
          {
            text: '线上商学院',
            path: '/OnlineBusinessSchool'
          },
          {
            text: '企业内训',
            path: ''
          },
          {
            text: '合作案例',
            path: '/Cooperationcases'
          }
          ]
        },
        {
          title: '关于我们',
          temp: [{
            text: '企业简介',
            path: '/aboutUs'
          },
          {
            text: '联系我们',
            path: ''
          },
          {
            text: '加入我们',
            path: ''
          },
          {
            text: '师资团队',
            path: ''
          },
          // {
          //   text: '合作案例',
          //   path: '/Cooperationcases'
          // },
          {
            text: 'APP下载',
            path: '/download'
          }
          ]
        }
      ]
    }
  },
  created () {
    this.getresourceList();
    console.log(window.location.host)  //www.jclingshou.vip  localhost:8081
    if (window.location.host == 'www.jclingshou.vip') {
      this.filingNumber = '鄂ICP备2023008190号-1'
    } else {
      this.filingNumber = '鄂ICP备11008218号-1'
    }
  },
  methods: {
    async getresourceList () {  //获取首页资源
      const res = await resourceList(this.data)
      // console.log(res)
      this.links = res.data;
    },
    toGov () {
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo')
    },
    toLink (item) {
      if (item.path && item.path != '' && this.$route.path != item.path) {
        this.$router.push(item.path)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.bottom_pass {
  // position: fixed;
  bottom: 0;
  left: 0;
  // height: 272px;
  background: #000;
  min-width: 1200px;
  // margin: 0 auto;
  box-sizing: border-box;
  color: #999999;
  padding: 40px 0 20px 0;
  .bottom_pass_box {
    width: 1200px;
    margin: 0 auto;
    .flexCenter {
      align-items: flex-start;
      .jc {
        margin-right: 40px;
        color: #fff;
        .logo {
          width: 160px;
          height: 40px;
          margin-bottom: 18px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .imgItem {
          width: 120px;
          text-align: center;
          margin-right: 40px;
        }
      }
      .fa {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        .fa_item {
          margin-right: 80px;
          .title {
            font-size: 16px;
            color: #fff;
            margin-bottom: 32px;
          }
          .li_item {
            color: #999999;
            font-size: 12px;
            margin-bottom: 24px;
            cursor: pointer;
          }
        }
      }
      .lx {
        width: 300px;
      }
    }

    .bottom {
      margin-top: 10px;
      width: 100%;
      padding-top: 10px;
      border-top: 1px solid #999;
      text-align: left;
      font-size: 11px;
      span:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
